import { del } from 'utils/http/del';

export async function userDashboardApiDeleteListingApplication(
  applicationId: string,
) {
  return del(`/data/listing-applications/${applicationId}`);
}
